import { NgModule } from '@angular/core';

import { HisAmountPipe } from 'hisng';

import { DocumentService } from './service/documents/document.service';
import { DocumentHelperService } from './service/documents/document-helper.service';
import { DocumentMetadataCategoryService } from './service/documents/documentMetadataCategory.service';

import { CommonSharedModule } from './common-shared.module';
import { AmountUtils } from './utils/amount-utils';
import { RightsUtils } from './utils/rights-utils';
import { CssClassUtils } from './utils/css-class-utils';
import { FinancingTypeValueService } from './service/financing-type/financing-type-value.service';
import { DynamicContentService } from './service/dynamic-content/dynamic-content.service';
import { DynamicClassService } from './service/dynamic-content/dynamic-class.service';
import { DynamicContentUtils } from './service/dynamic-content/dynamic-content-utils';
import { DynamicFieldValueUtils } from './service/dynamic-content/dynamic-field-value.utils';
import { DynamicFormGroupUtils } from './service/dynamic-content/dynamic-form-group-utils';
import { DataDictionaryUtils } from './utils/data-dictionary-utils';
import { ProviderManager } from './utils/provider-manager';

/**
 * CoreModule for common components.
 */
@NgModule( {
    imports: [
        CommonSharedModule,
    ],
    declarations: [
    ],
    exports: [
        CommonSharedModule,
    ],
    providers: [
        HisAmountPipe,

        FinancingTypeValueService,
        // documents
        DocumentService,
        DocumentHelperService,
        DocumentMetadataCategoryService,
        // dynamic stuff
        DynamicContentService,
        DynamicClassService,

        AmountUtils,
        CssClassUtils,
        RightsUtils,
        DynamicContentUtils,
        DynamicFieldValueUtils,
        DynamicFormGroupUtils,
        DataDictionaryUtils,
        ProviderManager
    ],
} )

export class CommonCoreModule {
}
